import HttpStatusCode from 'frontcore/data/api-service/http-status-code'
import {
  APIServiceErrorResponse,
  APIServiceResponse,
  OldErrorResponse,
} from 'frontcore/data/api-service/types'
import { getErrorMessageFromResponse } from 'frontcore/utils/serverErrorsManager'

export class APIServiceConfigurationError extends Error {}

export const isAPIServiceErrorResponse = <SD>(response: APIServiceResponse): response is APIServiceErrorResponse<SD> => {
  const data = response.data
  if (data == null || typeof data !== 'object') { return false }
  return 'service_code' in data && Number.isInteger(data.service_code)
}

export const isOldErrorResponse = (error: unknown): error is OldErrorResponse => {
  if (
    error === null
    || typeof error !== 'object'
    || !('status' in error)
  ) {
    return false
  }
  return true
}

export abstract class APIServiceError<SD = unknown> extends Error {
  protected response?: APIServiceErrorResponse<SD>

  serviceCode?: APIServiceErrorResponse<SD>['data']['service_code']
  status: HttpStatusCode

  constructor (response: APIServiceResponse) {
    super()
    if (isAPIServiceErrorResponse<SD>(response)) {
      this.response = response
      this.serviceCode = response.data.service_code
      this.message = response.data.localized_message
    } else {
      this.message = this.getLegacyMessage(response)
    }
    this.status = response.status
  }

  getLegacyMessage (response: APIServiceResponse) {
    try {
      const errorMessage = getErrorMessageFromResponse(response)
      return Array.isArray(errorMessage) ? errorMessage[0] : errorMessage
    } catch {
      return '[APIService] Unknown error.'
    }
  }
}

export class UnknownAPIServiceResponseError extends APIServiceError {}
